import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import authenticationAPI from 'api/authentication'
import Email from 'components/authentication/form-fields/Email'
import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import { UpperBackText } from 'components/authentication/UpperBackText'
import { AlertText } from 'components/common/Alert'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export const RequestPasswordReset: React.FC<{
  requestPasswordReset?: (email: string) => Promise<void>
}> = ({ requestPasswordReset = authenticationAPI.requestPasswordReset }) => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')

  const handleChange = ({ target }) => setEmail(target.value)

  const handleSubmit = (event) => {
    event.preventDefault()

    requestPasswordReset(event.target.email.value)
      .then(() => {
        toast({
          type: 'info',
          text: (
            <AlertText data-test-request-password-success>
              Password reset email sent
            </AlertText>
          )
        })
        navigate('/')
      })
      .catch((err) => {
        toast({
          type: 'error',
          text: (
            <AlertText data-test-request-password-error>
              {messageFromResponseError(
                err,
                'Unable to request a password reset. Please try again later.'
              )}
            </AlertText>
          )
        })
      })
  }

  return (
    <SignedOutFormContainer>
      <UpperBackText to="/login">Back to login</UpperBackText>
      <SignedOutForm title="Reset Password" onSubmit={handleSubmit}>
        <Email email={email} handleChange={handleChange} />
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}
